import React from 'react';

export default function HeroVisual() {
  // A lightweight placeholder component for future face image and analysis animation integrations.
  // Currently renders nothing to keep the hero layout clean without adding visual clutter.
  return null;
}
